export abstract class Entity{
  public id: string;

  protected constructor(id: string) {
    this.id = id;
  }
}
